var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.isVisible,
        transition: false,
        "max-width": 400,
        persistent: false,
      },
      on: {
        "click:outside": function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _vm.isVisible
        ? _c("FormInfoCategory", {
            on: {
              submit: function ($event) {
                return _vm.$emit("submit")
              },
              cancel: function ($event) {
                return _vm.$emit("close")
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }